export type Courier = string;

export type Hub = {
  hub: string;
  name: string;
  street: string;
  suburb: string;
  state: string;
  postcode: string;
  country_code: string;
  company: string;
};

export type Connection = {
  courier: Courier;
  start: string;
  end: string;
  zone: string;
  account?: string;
  priority: string;
  book_on_scan: string;
  book_on_booking: string;
  book_on_tracking_from_previous_leg: string;
};

export type Serviceability = {
  courier: Courier;
  dropoff: 'n' | 'y';
  pickup: 'n' | 'y';
  suburb: string;
  postcode: string;
  state: string;
  dropoff_zone: string;
  pickup_zone: string;
};

export enum FileType {
  Serviceability = 'Serviceability',
  Hubs = 'Hubs',
  Connections = 'Connections',
  Visualise = 'Visualise',
}

export type NetworkFile = {
  id: string;
  name: string;
  type: FileType;
  content?: string; // CSV content or reference
  dateAdded: string;
};

export type Tab =
  | 'overview'
  | 'hubs'
  | 'serviceability'
  | 'connections'
  | 'visualise'
  | 'testroute';

export type LogisticNetwork = {
  id: string;
  name: string;
  files: NetworkFile[];
};

// Routing types
export type RoutingNodeType = 'CourierZone' | 'Hub' | 'Locality';

export type RoutingNode = {
  id: string;
  name: string;
  type: RoutingNodeType;
  data: unknown;
  network: string;
};

export type RoutingEdgeLabel = 'DROPOFF' | 'PICKUP' | 'TRANSFER';

export type RoutingEdge = {
  start_id: string;
  end_id: string;
  courier_zone_id: string;
  label: RoutingEdgeLabel;
  network: string;
  account?: string | null;
  priority: number;
  booking_trigger_book_on_scan: boolean;
  booking_trigger_book_on_booking: boolean;
  booking_trigger_book_on_tracking_from_previous_leg: boolean;
};

export type Address = {
  streetAddress?: string;
  suburb: string;
  postcode: string;
  state: string;
  countryCode?: string;
};

export type RouteLeg = {
  courier: {
    code: string;
    sortCode: string;
    account?: string;
  };
  from: {
    type: string;
    id: string;
    name: string;
    address: Address;
  };
  to: {
    type: string;
    id: string;
    name: string;
    address: Address;
  };
};

export type Route = {
  legs: RouteLeg[];
  compatibility: {
    depotCode: string;
    lyneSortCode: string;
    lyneZone: string;
  };
};

export type RoutingRequest = {
  from: Address;
  to: Address;
};
